import React, { useState } from "react";
import { Alert } from "reactstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import StepCompleteActionButton from "./StepCompleteActionButton";
import { editUser } from "helpers/fakebackend_helper";

const PhoneNumberStep = ({ step, token, email, onNext }) => {
    const [phone, setPhone] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const onClickButton = async () => {
        setError("");

        if (!phone || phone.length < 10) {
            setError("Please enter a valid phone number.");
            return;
        }

        setLoading(true);

        try {
            const res = await editUser(token, { phone_number: phone, email });

            if (res.code === 1) {
                setLoading(false);
                onNext();
            } else {
                setLoading(false);
                setError(res.message || "An error occurred");
            }
        } catch (e) {
            setLoading(false);
            setError(e.message || "Unexpected error. Please try again.");
        }
    };

    return (
        <>
            {error && (
                <Alert color="danger" className="text-start">
                    {error}
                </Alert>
            )}

            <h1 className="text-dark mb-4 fw-semibold">{step.step_title}</h1>
            <h6 className="text-dark mb-4" style={{ whiteSpace: "pre-line" }}>{step.step_description}</h6>

            <PhoneInput
                value={String(phone)}
                country={"us"}
                onChange={(v) => setPhone(v)}
                enableSearch={true}
                countryCodeEditable={false}
                inputProps={{
                    name: "phone_number",
                    autoComplete: "tel",
                    onPaste: (event) => {
                        let data = event.clipboardData.getData("Text").replace(/\D/g, "");
                        if (data.startsWith("1")) data = data.slice(1);
                        if (data.startsWith("0")) data = data.slice(1);
                        const final = "1" + data;
                        setPhone(final);
                    },
                }}
                inputStyle={{
                    width: "100%",
                    height: "50px",
                    fontSize: "1.1rem",
                }}
                containerStyle={{ width: "100%", marginBottom: 15 }}
            />

            <StepCompleteActionButton
                label={loading ? "Loading..." : "CONTINUE"}
                onClick={onClickButton}
                disabled={loading}
            />
        </>
    );
};

export default PhoneNumberStep;